
const digest = '1619086d75bde607b5fac6bcde1e0ab7e63a8e8a8439e5f469e4a291222688b3';
const classes = {"wrapper":"_wrapper_1g34a_1"};
const css = `._wrapper_1g34a_1 {
  font-family: Rubik, "sans-serif";
  color: #ffffff;
  border-radius: 10px;
  font-size: 11px;
  padding: 4px 8px 2px 8px;
  background: rgb(23, 101, 216);
  background: linear-gradient(90deg, rgb(23, 101, 216) 0%, rgb(23, 158, 216) 100%);
  font-weight: 600;
  max-width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  